import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../../utils/helpers";
import { styles } from "./adminStyles";

const AlarmTab = ({ profile }) => {
  const [alarmRules, setAlarmRules] = useState([]);
  const [alarmProducts, setAlarmProducts] = useState({});
  const [newAlarmProduct, setNewAlarmProduct] = useState("");
  const [newAlarmCondition, setNewAlarmCondition] = useState("above");
  const [newAlarmTarget, setNewAlarmTarget] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const loadAlarmRules = async () => {
    try {
      const res = await axios.get(`${API}/alarm/rules?profile=${profile || 'default'}`);
      setAlarmRules(res.data.rules || []);
      setAlarmProducts(res.data.products || {});
    } catch (e) { console.error(e); }
  };

  useEffect(() => { loadAlarmRules(); }, [profile]); // eslint-disable-line react-hooks/exhaustive-deps

  const addAlarmRule = async () => {
    if (!newAlarmProduct || !newAlarmTarget) { setError("Urun ve hedef fiyat zorunlu!"); setTimeout(() => setError(""), 3000); return; }
    try {
      await axios.post(`${API}/alarm/rules`, { product: newAlarmProduct, condition: newAlarmCondition, target: parseFloat(newAlarmTarget), profile });
      setNewAlarmProduct(""); setNewAlarmTarget("");
      loadAlarmRules();
      setSuccess("Alarm eklendi!"); setTimeout(() => setSuccess(""), 3000);
    } catch (err) { setError(err.response?.data?.detail || "Alarm eklenemedi!"); setTimeout(() => setError(""), 3000); }
  };

  const deleteAlarmRule = async (id) => {
    if (!window.confirm("Bu alarmi silmek istediginize emin misiniz?")) return;
    try {
      await axios.post(`${API}/alarm/rules/delete`, { id });
      loadAlarmRules();
      setSuccess("Alarm silindi!"); setTimeout(() => setSuccess(""), 3000);
    } catch (e) { console.error(e); }
  };

  const toggleAlarmRule = async (id) => {
    try { await axios.post(`${API}/alarm/rules/toggle`, { id }); loadAlarmRules(); } catch (e) { console.error(e); }
  };

  return (
    <div style={{display: 'flex', justifyContent: 'center', padding: '30px 20px'}}>
      <div style={styles.panel}>
        <h1 style={styles.title}>Fiyat Alarmlari</h1>
        {success && <p style={styles.success}>{success}</p>}
        {error && <p style={styles.error}>{error}</p>}

        <div style={{...styles.section, marginBottom: '20px'}}>
          <h3 style={{ color: '#09301E', marginBottom: '12px' }}>Yeni Alarm Ekle</h3>
          <select value={newAlarmProduct} onChange={e => setNewAlarmProduct(e.target.value)}
            style={{...styles.input, marginBottom: '10px'}} data-testid="alarm-product-select">
            <option value="">Urun Secin...</option>
            {Object.entries(alarmProducts).map(([k, v]) => (
              <option key={k} value={k}>{v}</option>
            ))}
          </select>
          <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
            <select value={newAlarmCondition} onChange={e => setNewAlarmCondition(e.target.value)}
              style={{...styles.input, flex: 1}} data-testid="alarm-condition-select">
              <option value="above">Ustune Cikarsa</option>
              <option value="below">Altina Duserse</option>
            </select>
            <input type="number" placeholder="Hedef Fiyat" value={newAlarmTarget}
              onChange={e => setNewAlarmTarget(e.target.value)}
              style={{...styles.input, flex: 1}} data-testid="alarm-target-input" />
          </div>
          <button onClick={addAlarmRule} style={{...styles.button, background: '#334155', color: '#fff'}} data-testid="add-alarm-btn">
            Alarm Ekle
          </button>
        </div>

        <div style={styles.section}>
          <h3 style={{ color: '#09301E', marginBottom: '12px' }}>Mevcut Alarmlar</h3>
          {alarmRules.length === 0 ? (
            <p style={{ color: '#888', textAlign: 'center', padding: '20px' }}>Henuz alarm eklenmedi</p>
          ) : (
            alarmRules.map(rule => (
              <div key={rule.id} data-testid={`alarm-item-${rule.id}`} style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '12px', borderBottom: '1px solid #ddd', gap: '8px', flexWrap: 'wrap'
              }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{rule.product_label}</div>
                  <div style={{ fontSize: '12px', color: '#888' }}>
                    {rule.condition === 'above' ? 'Ustune cikarsa' : 'Altina duserse'}: {Number(rule.target).toLocaleString('tr-TR')}
                  </div>
                  {rule.triggered && <span style={{ fontSize: '11px', color: '#ef4444', fontWeight: 'bold' }}>TETIKLENDI</span>}
                </div>
                <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                  <button onClick={() => toggleAlarmRule(rule.id)} data-testid={`toggle-alarm-${rule.id}`}
                    style={{
                      padding: '6px 12px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold',
                      background: rule.active ? '#22c55e' : '#888', color: '#fff'
                    }}>
                    {rule.active ? 'Aktif' : 'Pasif'}
                  </button>
                  <button onClick={() => deleteAlarmRule(rule.id)} data-testid={`delete-alarm-${rule.id}`}
                    style={{ padding: '6px 12px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold', background: '#e74c3c', color: '#fff' }}>
                    Sil
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        <a href={`/alarm?profile=${profile}`} target="_blank" rel="noopener noreferrer"
          style={{...styles.backButton, display: 'block', textAlign: 'center', textDecoration: 'none', marginTop: '20px'}}>
          Alarm Ekranini Ac
        </a>
        <button onClick={() => window.location.href = profile === "default" ? "/" : `/${profile}`} style={{...styles.backButton, marginTop: '10px'}}>Fiyat Sayfasina Don</button>
      </div>
    </div>
  );
};

export default AlarmTab;
